import React from "react";
import { Datagrid, List, TextField } from "react-admin";
import axios from "axios";
import { useNotify, useRedirect } from "ra-core";

import { constants } from "../../utils/constants";
import { envSettings } from "../../settings/env";

export const SMSLogsList = (props) => {
	const notify = useNotify();
	const redirect = useRedirect();

	const handleBlockCountry = async (countryCode) => {
		try {
			const res = await axios.post(
				`${envSettings.baseUrl}/smsLogs/block-country`,
				{
					countryCode,
				}
			);
			if (res.status === 200) {
				notify("Blocked Successfully!", "success");
				redirect("/smsLogs");
			} else {
				notify("Failed!", "error");
			}
		} catch (error) {
			notify(
				error.response?.data?.message || "An error occurred!",
				"error"
			);
		}
	};

	const BlockCountryButton = ({ record }) => {
		if (!record) return null;
		return (
			<button
				onClick={() => {
					handleBlockCountry(record.countryCode);
				}}
			>
				Block Country
			</button>
		);
	};

	return (
		<List {...props} perPage={constants.perPage} bulkActionButtons={false}>
			<Datagrid rowClick="edit">
				<TextField source="phoneNumber" />
				<TextField source="countryCode" />
				<TextField source="createdOn" />

				<BlockCountryButton />
			</Datagrid>
		</List>
	);
};
